import { SearchChangeProps } from 'components/www/availability-search/SearchHeader';
import { SearchFilterType } from 'components/www/availability-search/filters/SearchFiltersDialog';
import { assertNever } from '@tock/shared/utils/typeUtils';
import _ from 'lodash';

type AppliedSearchFilterCountParams = Partial<
  Pick<SearchChangeProps, 'cuisines' | 'experienceTags' | 'priceRange' | 'type'>
>;

/**
 * Returns the total count of search filters applied for a given search filter type (e.g., "Sushi" and "Pizza" cuisines applied would return 2)
 */
const getAppliedFilterCountForSearchFilter = (
  filterType: SearchFilterType,
  { cuisines, experienceTags, priceRange, type }: AppliedSearchFilterCountParams
) => {
  switch (filterType) {
    case 'CUISINES':
      return cuisines?.length ?? 0;
    case 'OFFERING_TYPE':
      return !type || type === 'ALL_EXPERIENCES' ? 0 : 1;
    case 'PRICE':
      return priceRange ? 1 : 0;
    case 'SEATING_AREA':
      return experienceTags?.experienceTagSeatingArea?.length ?? 0;
    case 'UNIQUE_EXPERIENCES':
      return _.sumBy(
        [
          experienceTags?.experienceTagCampaign,
          experienceTags?.experienceTagAll,
          experienceTags?.experienceTagDineIn,
          experienceTags?.experienceTagToGo,
        ],
        (tagType) => tagType?.length ?? 0
      );
    default:
      assertNever(filterType);
  }
};

/**
 * Returns the total count of search filters applied for a give list of filter types
 */
export const getAppliedFiltersCountForVisibleFilters = (
  visibleFilters: SearchFilterType[],
  appliedFilterParams: AppliedSearchFilterCountParams
) =>
  _.sumBy(visibleFilters, (filterType) =>
    getAppliedFilterCountForSearchFilter(filterType, appliedFilterParams)
  );
